import React, { useMemo } from "react";
import { twMerge } from "tailwind-merge";

import { useStoredData, countFilters } from "@/store/Context";
import useVaults from "@/hooks/api/useVaults";

import GridBarFiltersChain from "@/components/Grid/Bar/Filters/Chain";
import GridBarFiltersYieldType from "@/components/Grid/Bar/Filters/YieldType";
import GridBarFiltersAtomClear from "@/components/Grid/Bar/Filters/Atom/Clear";
import GridBarFiltersSharpeRange from "@/components/Grid/Bar/Filters/SharpeRange";
import GridBarFiltersTvlRange from "@/components/Grid/Bar/Filters/TvlRange";
import GridBarFiltersProtocol from "@/components/Grid/Bar/Filters/Protocol";
import GridBarFiltersSuperPools from "@/components/Grid/Bar/Filters/SuperPools";
import GridBarFiltersToken from "@/components/Grid/Bar/Filters/Token";
import GridBarFiltersUnauthenticated from "@/components/Grid/Bar/Filters/Unauthenticated";
import GridBarFiltersApyRange from "@/components/Grid/Bar/Filters/ApyRange";
import GridBarFiltersRewards from "@/components/Grid/Bar/Filters/Rewards";

interface LayoutSidebarModeFiltersProps {
  className?: string;
  headerClassName?: string;
}

export default function LayoutSidebarModeFilters({ className, headerClassName }: LayoutSidebarModeFiltersProps) {
  const storedData = useStoredData();
  const { data: rawVaults } = useVaults("fully-cached");

  // @todo: remove this filtering for account vaults
  const vaults = useMemo(() => {
    return rawVaults?.filter(vault => !["hidden"].includes(vault.visibility));
  }, [rawVaults]);

  const filtersCount = useMemo(() => {
    return countFilters(storedData.filters);
  }, [storedData.filters]);

  return (
    <section className={twMerge("relative max-h-screen overflow-y-scroll p-6 pt-[60px]", className)}>
      <header className={twMerge("fixed top-0 z-50 flex w-[370px] items-center justify-start space-x-2 bg-neutral-25 py-2.5", headerClassName)}>
        <h2 className="txt-header-dgt my-0 text-[16px] leading-10">Filters</h2>
        <span className="sup-badge w-5 font-mono font-bold">{filtersCount > 9 ? "9+" : filtersCount}</span>
        {filtersCount > 0 && <GridBarFiltersAtomClear dispatchAction={{ type: "clearAllFilters" }} />}
      </header>

      <GridBarFiltersRewards />
      <GridBarFiltersSuperPools />
      <GridBarFiltersChain vaults={vaults} />
      <GridBarFiltersProtocol vaults={vaults} />
      <GridBarFiltersToken vaults={vaults} />
      <GridBarFiltersYieldType vaults={vaults} />
      <GridBarFiltersUnauthenticated />
      <GridBarFiltersTvlRange vaults={vaults} />
      <GridBarFiltersApyRange vaults={vaults} />
      <GridBarFiltersSharpeRange vaults={vaults} />
    </section>
  );
}
